/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LocationDetailsForOpenstack extends models.LocationDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("LocationDetailsForOpenstack");
    }

    getFixupPrototypeFunction() { return LocationDetailsForOpenstack.fixupPrototype; }

    static newInstance(model: Partial<LocationDetailsForOpenstack>): LocationDetailsForOpenstack {
        let obj = Object.assign(new LocationDetailsForOpenstack(), model);
        LocationDetailsForOpenstack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LocationDetailsForOpenstack>): LocationDetailsForOpenstack {
        if (!model) return null;
        return LocationDetailsForOpenstack.newInstance(<LocationDetailsForOpenstack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LocationDetailsForOpenstack) {
        if (!obj) return;

        models.LocationDetailsForOpenstack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LocationDetailsForOpenstack): boolean {
        if (models.LocationDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LocationDetailsForOpenstack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Domain of the location
     */
    domain_id: string;

}
